<template>
  <cx-modal id="slider-modal" 
    v-show="images.length > 0" 
    v-on:dismiss="dismiss"
    v-trap-focus="{ escFunc: dismiss, live: true }">
    <div class="slider-modal__counter cx-div--sm">
      {{$refs && $refs.slider && $refs.slider.activeIdx}} / {{images.length}}
    </div>
    <cx-slider-v2 
      :presetActiveIdx="activeIdx"
      ref="slider"
      hidePager arrowNagv>
      <cx-slider-item v-for="image in images" :key="image.src">
        <div class="cx-media">
          <cx-img 
            tag="div"
            :imgSrc="image.src"
            lazyLoad
            class="cx-media__img">
            <div class="cx-media__caption cx-t10"
            >{{image.description}}</div>
            <div class="cx-media__caption cx-t20"
            >{{image.title}}</div>
          </cx-img>
        </div>
      </cx-slider-item>
    </cx-slider-v2>
  </cx-modal>
</template>

<script>
import autoFocus from '../mixins/autoFocus';

export default {
  name: 'slider-modal',
  mixins: [autoFocus],
  data() {
    return {
      activeIdx: 1,
      images: [],
      recoverFocusElm: null
    }
  },
  mounted() {
    window.SliderModal = {
      open: this.open,
      close: this.dismiss
    }
  },
  beforeDestroy() {
    window.SliderModal = null;
  },
  methods: {
    open: function(inputImages, activeIdx = 1) {
      this.images = [...inputImages];
      this.activeIdx = activeIdx;
      setTimeout(this._af_autoFocus, 0);
      this.recoverFocusElm = document.activeElement;
    },
    dismiss: function() {
      this.images = [];
      this.activeIdx = 1;
      this.recoverFocusElm && this.recoverFocusElm.focus();
    }
  }
}
</script>

<style lang="scss">
</style>
